export default __webpack_public_path__ + "static/media/OLI_APP_4C_LTBG.6f18b359.png";